let questionSocket = undefined;
const PROD_SCHEME = `wss`;
const DEV_SCHEME = `ws`;

let webSocketIntervalId = 0;

let websocketOnMessageEventFunction = undefined;

export class QuestionWebSocketService {

  startWebSocket() {
    const scheme = (process.env.NODE_ENV === "development") ? DEV_SCHEME : PROD_SCHEME;
    const url = `${scheme}://${location.host}/ws/question`;
    let ws = new WebSocket(url);
    ws.binaryType = "arraybuffer";
    ws.onclose = event => {
      if (event.wasClean) {
        // eslint-disable-next-line no-console
        console.log(`[close] Connection closed cleanly, code=${event.code} reason=${event.reason}`);
      } else {
        // e.g. server process killed or network down
        // event.code is usually 1006 in this case
        // eslint-disable-next-line no-console
        console.log("[close] Connection died");
      }
      ws = null;
    };
    ws.onopen = () => this.sendGoToFirstPage();

    if (websocketOnMessageEventFunction) {
      ws.onmessage = websocketOnMessageEventFunction;
    }

    // eslint-disable-next-line no-console
    ws.onerror = errorEvent => console.error("[error]", errorEvent);

    this.startPing();
    return ws;
  }

  startPing() {
    clearInterval(webSocketIntervalId);
    // eslint-disable-next-line no-console
    console.log("start ping");
    webSocketIntervalId = setInterval(() => this.send({"action": "ping"}), 20000);
  }

  bindOnMessage(eventFunction) {
    websocketOnMessageEventFunction = eventFunction;
    if (questionSocket === undefined) {
      questionSocket = this.startWebSocket();
    }
    questionSocket.onmessage = websocketOnMessageEventFunction;
    if (questionSocket.readyState === questionSocket.OPEN) {
      this.sendGoToFirstPage();
    }
  }

  reconnectWebsocket() {
    if (questionSocket !== undefined) {
      questionSocket.close();
    }
    questionSocket = this.startWebSocket();
  }

  sendGoToFirstPage() {
    this.send({"action": "goToFirstPage"});
  }

  send(jsonObject) {
    // eslint-disable-next-line no-console
    console.log("send event");
    const objectAsString = JSON.stringify(jsonObject);
    questionSocket.send(objectAsString);
  }

}